import React from 'react';
import App from './App';
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { AppToastHost } from "./components/AppToast";
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./redux/store";
import './utils/patchResizeObserver';
import "./Localization/i18n";
import i18n from "./Localization/i18n"; 
// import { GoogleOAuthProvider } from '@react-oauth/google';


const savedLang = localStorage.getItem("appLanguage");
if (savedLang) {
  i18n.changeLanguage(savedLang);

  // Apply RTL/LTR immediately
  document.documentElement.dir = savedLang.startsWith("ar") ? "rtl" : "ltr";
  document.documentElement.lang = savedLang;
}

const container = document.getElementById("root");

// Add global error handler
const originalConsoleError = console.error;
console.error = function(message, ...args) {
  // Check if this is a "findDOMNode is deprecated" warning from React StrictMode
  if (typeof message === 'string' && 
      (message.includes('findDOMNode') || message.includes('act(') || message.includes('Warning:'))) {
    return;
  }
  
  // Log all other errors normally
  originalConsoleError.apply(console, [message, ...args]);
};

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <Router>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}> */}
            <App/>
            <AppToastHost position="top-center" limit={5} newestOnTop />
          {/* </GoogleOAuthProvider> */}
        </PersistGate>
      </Provider>
    </Router>
  );
} else {
  console.error('Root element not found');
}
